import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form } from 'react-bootstrap';
import { Button } from "@app/components";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { setStep } from '@app/store/reducers/enrollmentForm';
import { getActiveTemplateByType } from '@app/services/contentTemplates';

const mediaConsents = [
    {id:'true', name:'Yes'},
    {id:'false', name:'No'},
];

const EnrollmentStep4 = (props) => {
        
    const enrollmentStore = useSelector((state: any) => state.enrollmentForm);
    const [isLoading, setLoading] = useState(false);
    const [templateContent, setTemplateContent] = useState<any>(null);
    const [loadingTemplate, setLoadingTemplate] = useState(true);
    const dispatch = useDispatch();
    
    useEffect(() => {
        fetchMediaConsentTemplate();
        return () => {

        }
    },[]);

    const fetchMediaConsentTemplate = async () => {
        try {
            setLoadingTemplate(true);
            const franchiseId = enrollmentStore?.formData?.franchise_id;
            if (franchiseId) {
                const template = await getActiveTemplateByType(franchiseId, 'media_consent');
                if (template) {
                    setTemplateContent(template);
                }
            }
        } catch (error) {
            console.error('Error fetching media consent template:', error);
        } finally {
            setLoadingTemplate(false);
        }
    };

    const renderTemplateContent = () => {
        if (!templateContent) return null;

        try {
            const parsed = JSON.parse(templateContent.content);
            let htmlContent = parsed.htmlContent || '';
            
            // Replace all placeholders with their values from parsed content
            Object.keys(parsed).forEach(key => {
                if (key !== 'htmlContent' && parsed[key] !== undefined && parsed[key] !== '') {
                    const replacementValue = parsed[key];
                    const regex = new RegExp(`\\[${key}\\]`, 'g');
                    htmlContent = htmlContent.replace(regex, replacementValue);
                }
            });
            
            return (
                <div 
                    className="ql-editor" 
                    dangerouslySetInnerHTML={{ __html: htmlContent }}
                    style={{ padding: 0 }}
                />
            );
        } catch (error) {
            return (
                <div 
                    className="ql-editor" 
                    dangerouslySetInnerHTML={{ __html: templateContent.content }}
                    style={{ padding: 0 }}
                />
            );
        }
    };
    

    const { handleChange, values, handleSubmit, touched, errors, setFieldValue } = useFormik({
        initialValues: {
            step: 4,
            media_consent: enrollmentStore?.formData?.media_consent || '',
        },
        validationSchema: Yup.object({
            media_consent: Yup.string().trim().required('Please select media consent'),
        }),
        onSubmit: (values) => {
            props?.updateEnrollmentDetailsAPI(values)
        },
        enableReinitialize: true,
    });

    return (
        <>
        <Form onSubmit={handleSubmit}>
        <div className="content mb-3">
            <h6 className="grey_wrapper_title">
                <i className="fas fa-camera-retro"/> &nbsp; 
                {templateContent?.title || 'Student Photography/Video Consent'}
            </h6>
            {loadingTemplate ? (
                <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : templateContent ? (
                <div className="">
                    {renderTemplateContent()}
                </div>
            ) : (
                <div className="alert alert-danger">
                    <i className="fas fa-exclamation-triangle mr-2"></i>
                    We're unable to load the required information at this time. Please contact us for assistance or try again later.
                </div>
            )}
            <div className='row'>
                <div className="col-sm-4">
                    <div className="form-group">
                        {/* <label htmlFor="exampleInputGender">Gender <span className="required">*</span></label> */}
                        <select
                            className="form-control"
                            name="media_consent"
                            onChange={handleChange} 
                            value={values.media_consent}
                            disabled={!templateContent}
                        >
                            <option value="">--Please select--</option>
                            {mediaConsents.map((obj) => (
                                <option key={obj.id} value={obj.id}>
                                    {obj.name}
                                </option>
                            ))}
                        </select>
                        {(touched.media_consent && errors.media_consent) && (
                            <div className="text-danger">
                                {errors.media_consent}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
        <div className="mx-4 d-flex justify-content-between align-items-center">
            <Button type="button" isLoading={isLoading} onClick={ () => dispatch(setStep(enrollmentStore?.step - 1))} className="btn btn-default"> Back </Button>
            <Button type="submit" isLoading={isLoading} className="btn btn-primary" disabled={!templateContent || loadingTemplate}> Next </Button>
        </div>
        </Form>
        </>
  );
};

export default EnrollmentStep4;
